<template>
  <div class="container rel">
    <div class="close" @click="closeDialog('')">
      <el-icon>
        <Close />
      </el-icon>
    </div>
    <div class="tips">{{ t('検索した情報はどうですか？') }}</div>
    <div class="operate flex">
      <div class="flex-col fx-1 fle-cen flex-ter" @click="checkAgree(1)">
        <img src="https://static-s.theckb.com/BusinessMarket/Client/icon_dissatisfied.png" alt="">
        <div class="type">{{ t('よいです') }}</div>
      </div>
      <div class="flex-col fx-1 fle-cen flex-ter" @click="checkAgree(0)">
        <img src="https://static-s.theckb.com/BusinessMarket/Client/icon_satisfied.png" alt="">
        <div class="type">{{ t('よくないです') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Close } from '@element-plus/icons-vue'
import { defineProps, defineEmits } from 'vue'
defineProps(['visible'])
const emit = defineEmits(['close'])

/** 关闭弹窗 */
const closeDialog = (value) => {
  emit('close', value)
}

/** 是否满意 */
const checkAgree = (val) => {
  emit('close', val)
}

</script>

<style lang="scss" scoped>

.container {
  width: 300px;
  height: 173px;
  background: linear-gradient(330deg, #FF7405 0%, #FF4002 100%);
  border-radius: 20px;

  .close {
    position: absolute;
    padding: 10px;
    color: #fff;
    font-size: 20px;
    font-weight: bolder;
    right: 0;
    top: 0;
    cursor: pointer;
  }

  .tips {
    font-size: 18px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 25px;
    padding-top: 22px;
    text-align: center;
  }

  .operate {
    width: 300px;
    height: 104px;
    background: #FFFFFF;
    box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.5);
    border-radius: 20px;
    position: absolute;
    top: 70px;

    .flex-col {
      width: 50%;
      cursor: pointer;

      img {
        width: 36px;
      }
    }

    .type {
      margin-top: 8px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;

    }
  }
}
</style>
